import styled from "styled-components";

import * as UI from "../../../../../../modules/ui-kit";
import PropertiesOverview from "../../form/Components/PropertiesOverview";

export default function MaterialCard(props) {
    const {
        id,
        onEdit,
        onRemove,
        properties,
    } = props;
    return (
        <Styled>
            <span>{ id ?? "-" }</span>
            {
                properties && (
                    <PropertiesOverview
                        className="properties"
                        properties={ properties }
                    />
                )
            }
            <div className="buttons"></div>
            <div className="buttons">
                <UI.Button
                    onClick={ onEdit }
                >
                    Change
                </UI.Button>
                <UI.Button
                    onClick={ onRemove }
                >
                    Remove
                </UI.Button>
            </div>
        </Styled>
    );
}

const Styled = styled.div`
    background: #6661;
    border-radius: 4px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content min-content min-content;
    padding: 8px 16px;
    transition: 200ms;

    & > span {
        grid-column: 1 / -1;
    }

    & > .properties {
        grid-column: 1 / -1;
    }

    & > .buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;

        &:last-of-type {
            justify-content: flex-end;
        }
    }
`;
